const UNITS: string[] = [
  "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
  "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"
];
const TENS: string[] = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

/**
 * Converts a number (0-100) to its word representation.
 * e.g., 10 -> "ten", 25 -> "twenty-five", 100 -> "one hundred"
 * Returns an empty string for numbers outside the 0-100 range or invalid input.
 */
const numberToWords = (num: number): string => {
  if (typeof num !== 'number' || isNaN(num)) {
    return ""; 
  }
  
  // Assuming discounts are whole percentages and within 0-100
  // Math.floor handles potential float inputs, though discounts are expected to be integers.
  const n = Math.floor(num);

  if (n < 0 || n > 100) {
    return ""; 
  }

  if (n < 20) {
    return UNITS[n];
  }

  if (n < 100) {
    const tenDigit = Math.floor(n / 10);
    const unitDigit = n % 10;
    if (unitDigit === 0) {
      return TENS[tenDigit];
    }
    return `${TENS[tenDigit]}-${UNITS[unitDigit]}`;
  }

  if (n === 100) {
    return "one hundred";
  }

  return ""; // Should not be reached if n is within 0-100
};

/**
 * Converts a numeric discount value (e.g., 20 for 20%) to its word representation
 * followed by " percent" (e.g., "twenty percent").
 * Returns undefined if the discount is not a valid number, cannot be converted, or is outside the 0-100 range.
 */
export const convertNumericDiscountToWords = (numericDiscount: number | undefined): string | undefined => {
  if (typeof numericDiscount !== 'number' || isNaN(numericDiscount)) {
    return undefined; // No discount or invalid input
  }

  // Discounts are typically non-negative.
  if (numericDiscount < 0) {
    return undefined;
  }

  const words = numberToWords(numericDiscount);
  
  if (!words) {
    // numberToWords returned empty (e.g., out of range like > 100, or other conversion issue)
    return undefined; 
  }
  return `${words} percent`;
}; 